module.exports = __webpack_public_path__ + "img/psychological_renbao_04.e70d312a.jpg";